module.exports = __webpack_public_path__ + "img/symbol_4.fc06b5b8.png";